<mat-card>
	<mat-card-header>
	    <mat-card-title></mat-card-title>
	</mat-card-header>
    <mat-card-content>
        <form action="" method="post" [formGroup]="uploadForm"
                   enctype="multipart/form-data">
	        <div style="display:flex;flex-direction:row;gap:20px">
	            <mat-form-field style="width:25%" appearance="outline">
	                <mat-label>Document Name</mat-label>
		            <input matInput 		                   
                        type="text"
                        style="text-transform:uppercase"
                        id="docName"
                        name="docName" 				        
                        formControlName="docName"
                        placeholder="Document Name"
                        (input)="onDocNameInput()">

		        </mat-form-field>
	            <mat-form-field style="width:55%" appearance="outline">
	                <mat-label>Document Description</mat-label>
		            <input matInput 
                        type="text"
                        style="text-transform:uppercase"
                        id="docDescription"
                        name="docDescription" 				        
                        formControlName="docDescription"
                        placeholder="Document Description"
                        (input)="checkDirty(newDocument.description, 'docDescription'); onDocDescriptionInput()">

		        </mat-form-field>					    
		    </div>
		    <div>
                <button type="button" 
                        mat-raised-button 
                        color="accent"
                        (click)="fileInput.click()"
                        [disabled]="(entityUId == null || uploadDisabled)">
                        <i class="material-icons left">cloud</i> Choose File
                </button>
                <!-- Adding a div to hide the input because 
                     the hidden attribute does not work on input HTML tag
                 -->
                <input type="file"
                       id="file"
                       class="document-file-input"
                       (change)="onFileSelected($event)"
                       #fileInput>
		    </div>
        </form>
        <div class="container">
	        <div class="line"><mat-divider inset=“true”></mat-divider></div>
	        <div class="text mat-typography"><h2>Document List</h2></div>
	        <div class="line"><mat-divider inset=“true”></mat-divider></div>
        </div>                                
        <div style="display:flex;flex-wrap:wrap;gap:20px">
            <ng-container *ngFor="let oneDocument of documents; let i=index">
                <div *ngIf="isNewRow(i)"
                     style="flex-basis:100%;height:0">
                </div>                        
                <div style="clear:both;justify-content:center;align-items:center;width:250px">
                    <ngx-avatars  (clickOnAvatar)="avatarClicked($event, oneDocument)"			                              
  		                         name="{{getDocumentFileType(oneDocument.fileTypeREF)}}"
		                         [style]="customStyle"
		                         value="{{getDocumentLabel(oneDocument.entityType)}}" 
		                         bgColor="#000000" 
		                         fgColor="#58D3F7" size="60"
		                         textSizeRatio="2.5" [round]="true">
                    </ngx-avatars>
                    <br>  
                    <span style="position:absolute; padding-left:0px; 
                          text-align:left;width:200px;text-overflow:ellipsis;overflow:hidden;white-space: nowrap;">{{oneDocument.name}}</span>	                	              	                
                    <br/>
                    <span style="position:absolute; padding-left:0px; 
                          text-align:left;width:200px;word-wrap:break-word">Uploaded By: {{oneDocument.byUser}}</span>	                	              	                
                    <br/>
                    <span style="position:absolute; padding-left:0px; 
                          text-align:left;width:200px;word-wrap:break-word">Upload date: {{CyDateTime.convertToLocalDateDisp(oneDocument.createDT)}}</span>	                	              	                
                    <br/>
                    <br/>			                
	                <button *ngIf="oneDocument.edit"
	                        type="button" 
	                        mat-raised-button 
	                        color="accent"
	                        (click)="editDocument(i, oneDocument)">Edit
	                </button>
	                <button *ngIf="oneDocument.edit"
	                        style="margin:1px;"
	                        type="button" 
	                        mat-raised-button 
	                        color="accent"
	                        (click)="deleteDocument(i, oneDocument)">Delete
	                </button>
	                <button *ngIf="!oneDocument.edit"
	                        type="button" 
	                        mat-raised-button 
	                        color="accent"
	                        (click)="saveDocument(i, oneDocument)">Save
	                </button>
	                <button *ngIf="!oneDocument.edit"
	                        style="margin:1px;"
	                        type="button" 
	                        mat-raised-button 
	                        color="accent"
	                        (click)="cancelEdit(i, oneDocument)">Cancel
	                </button>
                </div>
            </ng-container>                                         
        </div>
    </mat-card-content>
</mat-card>
